import React from 'react';

import iconPin from '../../../../../../assets/images/icon-pin.png';

import './styles.css';

function MapInfo({
  title,
  latitude,
  longitude,
  location,
  description,
  noBackgroundColor,
  openMap,
}) {
  return (
    <div
      className={`DrawerContainer__infoContainer DrawerContainer__mapInfoContainer ${noBackgroundColor ? 'noBackground' : ''}`}
      onClick={() => openMap(latitude, longitude, location)}
    >
      <div className="flex">
        <p className="DrawerContainer__itemName">{title}</p>
        <p className="DrawerContainer__itemValue">{description || `${latitude}, ${longitude}`}</p>
      </div>
      <div>
        <div
          className="DrawerContainer__infoContainer"
        >
          <img alt="" src={iconPin} />
          <p className="DrawerContainer__itemName">Mapa</p>
        </div>
      </div>
    </div>
  );
}

export default MapInfo;
